import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import {
  ButtonDirective,
  CardBodyComponent,
  CardComponent,
  ColComponent,
  ContainerComponent,
  RowComponent
} from '@coreui/angular-pro';
import { TranslatePipe, TranslateService } from 'i18n';

@Component({
  selector: 'app-kyc-confirmed-page',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    CardComponent,
    CardBodyComponent,
    ContainerComponent,
    RowComponent,
    ColComponent,
    ButtonDirective,
    TranslatePipe
  ],
  styles: [`
    :host {
      display: block;
      position: absolute;
      inset: 0;
      overflow-y: auto;
    }
    :host { color: rgba(255, 255, 255, 0.9); }`
  ],
  templateUrl: './kyc-confirmed-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KycConfirmedPageComponent {
  private translateService = inject(TranslateService);

  lang = computed(() => this.translateService.getActiveLang());
}